import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { NavButton } from "@repo/ui/nav-button";
import { cn } from "@repo/ui/utils";
import type { CategoryPillSize, CategoryPillsProps } from "./category-pills.types";
interface CategoryPillProps {
  selected: boolean;
  onClick: () => void;
  size: CategoryPillSize;
  children: ReactNode;
}

/**
 * Single filter pill — `NavButton` wrapper with brand-token active /
 * hover colours overriding NavButton's open-water defaults. Not
 * exported on its own; consumers compose via `CategoryPills`.
 */
function CategoryPill(t0) {
  const $ = _c(9);
  const {
    selected,
    onClick,
    size,
    children
  } = t0;
  const t1 = size === "lg" ? "sm" : size;
  const t2 = size === "lg" && "desktop:h-12 desktop:gap-2 desktop:px-4 desktop:py-3 desktop:typography-component-sm-medium";
  const t3 = selected ? "bg-button-primary-background text-button-primary-text" : "text-text-primary hover:bg-surface-base-secondary";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = cn("shrink-0", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== onClick || $[5] !== selected || $[6] !== t1 || $[7] !== t4) {
    t5 = <NavButton variant="item" size={t1} active={selected} onClick={onClick} aria-pressed={selected} className={t4}>{children}</NavButton>;
    $[3] = children;
    $[4] = onClick;
    $[5] = selected;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}

/**
 * Horizontal row of filter pills with a leading "All" option. Shared by
 * `ResourceListing` and `CommercialTenantListing`. Returns null when
 * `categories` is empty so the caller doesn't have to gate it.
 */
export function CategoryPills(t0) {
  const $ = _c(22);
  const {
    categories,
    selectedCategoryId,
    onSelect,
    allLabel,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  if (categories.length === 0) {
    return null;
  }
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex items-center gap-2 overflow-x-auto pb-3 scrollbar-none", "desktop:flex-wrap desktop:overflow-x-visible desktop:pb-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = selectedCategoryId === null;
  let t4;
  if ($[2] !== onSelect) {
    t4 = () => onSelect(null);
    $[2] = onSelect;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== allLabel || $[5] !== size || $[6] !== t3 || $[7] !== t4) {
    t5 = <CategoryPill selected={t3} onClick={t4} size={size}>{allLabel}</CategoryPill>;
    $[4] = allLabel;
    $[5] = size;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== categories || $[10] !== onSelect || $[11] !== selectedCategoryId || $[12] !== size) {
    let t7;
    if ($[14] !== onSelect || $[15] !== selectedCategoryId || $[16] !== size) {
      t7 = category => <CategoryPill key={category._id} selected={selectedCategoryId === category._id} onClick={() => onSelect(category._id)} size={size}>{category.name}</CategoryPill>;
      $[14] = onSelect;
      $[15] = selectedCategoryId;
      $[16] = size;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = categories.map(t7);
    $[9] = categories;
    $[10] = onSelect;
    $[11] = selectedCategoryId;
    $[12] = size;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t6) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}